import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 10a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v4a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2l0 -4","key":"svg-0"}]]

const IconCrop169 = createReactComponent('outline', 'crop-16-9', 'Crop169', __iconNode);

export default IconCrop169;